module.exports = __webpack_public_path__ + "static/img/A57.608036aa.jpg";